const getters = {
  tableData: (state) => state.tableData,
  filters: (state) => state.filters,
  isEmpty: (state) => state.isEmpty
};

export default {
  getters
};
